'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import { LazyMotion } from 'framer-motion';
import PropTypes from 'prop-types';

const motionFeatures = () =>
    import('../utils/motion-features').then(res => res.default);

export const FramerMotionProvider = ({ children }) => {
    return (
        <LazyMotion strict features={motionFeatures}>
            {children}
        </LazyMotion>
    );
};

FramerMotionProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
